const Master = () => import(/* webpackChunkName: "master" */ '@/views/private/master/Index.vue')
const Product = () => import(/* webpackChunkName: "masterproduct" */ '@/components/master/Product.vue')
const Attribute = () => import(/* webpackChunkName: "masterattribute" */ '@/components/master/Attribute.vue')
const Category = () => import(/* webpackChunkName: "mastercategory" */ '@/components/master/Category.vue')
const Supplier = () => import(/* webpackChunkName: "mastersupplier" */ '@/components/master/Supplier.vue')
const Shift = () => import(/* webpackChunkName: "mastershift" */ '@/components/master/Shift.vue')
const ProductSupplier = () => import(/* webpackChunkName: "masterproductsupplier" */ '@/components/master/ProductSupplier.vue')

const routes = [
  {
    path: "/master",
    name: "master",
    component: Master,
    meta: {
      title: "Master"
    },
    children: [
      {
        path: '/master/product',
        name: 'master product',
        component: Product,
        meta: {
          title: "Produk"
        }
      },
      {
        path: '/master/attribute',
        name: 'attribute variant',
        component: Attribute,
        meta: {
          title: 'Atribut Varian'
        }
      },
      {
        path: '/master/category',
        name: 'category product',
        component: Category,
        meta: {
          title: 'Kategori Produk'
        }
      },
      {
        path: '/master/supplier',
        name: 'supplier',
        component: Supplier,
        meta: {
          title: 'Supplier'
        }
      },
      {
        path: '/master/shift',
        name: 'shift',
        component: Shift,
        meta: {
          title: 'Shift'
        }
      },
      {
        path: '/master/product-supplier',
        name: 'product supplier',
        component: ProductSupplier,
        meta: {
          title: 'Produk Supplier'
        }
      }
    ]
  },
  {
    path: "/log-aktifitas",
    name: "activityLog",
    component: () => import(/* webpackChunkName: "activitylog" */ '@/views/private/master/ActivityLog.vue'),
    meta: {
      title: "Log Aktifitas"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})